import * as React from "react";
import { forwardRef } from "react";
const SvgBankAccount = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24px", height: "24px", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "surface1" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(0%,0%,0%)",
  fillOpacity: 1
}, d: "M 22 11 L 22 7.828125 L 12 2.058594 L 2 7.828125 L 2 11 L 4 11 L 4 19 L 2 19 L 2 21 L 22 21 L 22 19 L 20 19 L 20 11 Z M 4 9 L 12 4.378906 L 20 9 Z M 6 19 L 6 11 L 8 11 L 8 19 Z M 10 19 L 10 11 L 14 11 L 14 19 Z M 18 19 L 16 19 L 16 11 L 18 11 Z M 18 19 " })));
const ForwardRef = forwardRef(SvgBankAccount);
export { ForwardRef as ReactComponent };
